export const brazeWhitelistEvents = [
  'Order Completed',
  'Gift Card Order Completed',
  'Screen View',
  'Photo Picked',
  'Web Email Captured',
  'Web Email Marketing Allowed',
  'Web Email Marketing Consent Given',
  'App Email Captured',
  'App Email Marketing Allowed',
  'App Email Marketing Consent Given',
  'Active on Site',
  'Phone Number Captured',
  '[Art] Email Captured',
  'Promo Code Added',
  'Promo Code Rejected',
  'Promo Code Updated',
  'Suspected Crash',
  'First Open',
  'Passed who is it for step',
  'Passed Who Is It For Step',
  'Add Promo Code Tapped',
  'Name Captured',
  'Promo Code Selected',
  'Initial Launch',
  'Restored photo bank',
  'Attribution Survey Answered',
  'Centerpiece Added',
  'Sms Consent Checkbox Tapped',
  'Phone Number Consent Given',
  'Promo Code Removed',
  'Consent Dialog Shown',
  'Cart Restored',
  'Cart: Bag Opened',
  'Cart: Quantity Changed',
  'Cart: Product Details Expanded',
  'Cart: Product Edit Tapped',
  'Cart: Remove Item Tapped',
  'Cart: Remove Item Confirmed',
  'Cart: Remove Item Cancelled',
  'Consent Dialog Closed',
  'Artwork Ordered',
  '[Art] Product Viewed',
  'Create Order Failed',
  'Order Management: Cancel Order Tapped',
  'Notification Permission Granted',
  'Notification Permission Declined',
  'No Consent Required',
  'Tiles Ordered',
  'Product Ordered',
  'AI Artwork Generation Completed',
  'AI Templates Photo Picked',
]
